import React, { useState, useEffect, useRef, useContext } from "react";
import { Paper, TextareaAutosize } from "@mui/material";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import "./../../Style/SalesDetailStyle.scss";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import jwtDecode from "jwt-decode";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
} from "../../Components/Alerts";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import PrintContent from "../../Print/PrintContent";
import { useHistory } from "react-router-dom";
import {
  FaTicketAlt,
  FaTimes,
  FaTrash,
  FaEnvelope,
  FaTable,
  FaFileInvoice,
} from "react-icons/fa";
import InsertSupplier from "../Suppliers/InsertSuppliers";
import InsertArticle from "../Article/InsertArticle";
import InputAdornment from "@mui/material/InputAdornment";
import CircularProgress from "@mui/material/CircularProgress";
import DataGridWithActions from "../../Components/DataGridWithActions";
import { detailsData } from "./ReturnToSupplierGrid";
import Autocomplete from "@mui/material/Autocomplete";
import Alert from "@mui/material/Alert";
import ButtonGroup from "@mui/material/ButtonGroup";
import {
  ElementsParagraph,
  TitleElements,
} from "../../Components/HeadersCRUD-s";
import { LinkAndClickButton } from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
// import { saveAs } from "file-saver";
import MuiButton from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AccountsAutocompleteInsert from "../../Components/AccountsAutocompleteInsert";
import ArticleAutocompleteInsert from "../../Components/ArticleAutocompleteInsert";
import ArticleAutocompleteEdit from "../../Components/ArticleAutocompleteEdit";

function InsertReturnToSupplier(props) {
  const history = useHistory();
  const { fiscalYear } = useContext(FiscalYearContext);

  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  useEffect(() => {
    setMinDate(`${fiscalYear}-01-01`);
    setMaxDate(`${fiscalYear}-12-31`);
  }, [fiscalYear]);

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    const selectedYear = new Date(selectedDate).getFullYear();

    // Kontrollo që data të jetë brenda vitit të caktuar
    if (selectedYear === fiscalYear) {
      setDate(selectedDate);
      setPayDate(selectedDate);
      fetchLastInvoiceNr(fiscalYear);

      // fetchLastInvoiceNr(fiscalYear);
    } else {
      // alert(`Ju lutemi zgjidhni një datë brenda vitit ${fiscalYear}.`);
      setDate(""); // Reset data në rast të gabuar
    }
  };

  const TranscationData = [
    {
      id: 1,
      type: "Vendore",
    },
    {
      id: 2,
      type: "Eksport",
    },
    {
      id: 3,
      type: "Sherbime jashtë vendit",
    },
    {
      id: 4,
      type: "Ngarkesa e Kundert",
    },
  ];

  const [lang, setLang] = useState("sq");

  const headers = authHeader();
  const email = LoginUserDetailed();
  const [logedEmail, setLogedEmail] = useState("");
  const [unId, setUnID] = useState("");
  //Per insertimin e Transaction
  const [date, setDate] = useState("");
  const [payDate, setPayDate] = useState("");
  const [coment, setComent] = useState("");
  const [invoiceNR, setInvoiceNR] = useState("");
  const [supplierID, setSupplierID] = useState("");
  const [clientBranchID, setClientBranchID] = useState("");
  const [transactionsType, setTransactionType] = useState(1);
  const [paymentOptions, setPaymentOptions] = useState("");
  const [priceWithVAT, setPriceWithVAT] = useState(0);

  //Per insertimin ne Article History
  const [articleID, setArticleID] = useState("");
  const [qtyOutput, setQtyOutput] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [priceWithoutVAT, setPriceWithoutVAT] = useState(0);
  const [total, setTotal] = useState(0);
  const [vatRates, setVATRates] = useState("");

  const [discountAmount, setDiscountAmount] = useState(0);
  const [perqindjaZbritjes, setPerqindjaZbritjes] = useState(0);

  const [hasClientBranch, setHasClientBranch] = useState(false);
  const [clientBranch, setClientBranch] = useState([]);

  // kjo konstante sherben per ta mbaajtur perkohesisht qmimin me tvsh te nje artikulli
  const [tempPriceWithVAT, setTempPriceWithVAT] = useState(0);
  const [showDeleteTransactionID, setShowDeleteTransactionID] = useState(false);

  const [deleteTransactionID, setDeleteTransactionID] = useState("");

  const [openDetails, setOpenDetails] = useState(false);

  //Keto konstante jan perdorur per ti shfaqur progres bar tek butonat
  const [insertingTransaction, setInsertingTransaction] = useState(false);
  const [insertingArticle, setInsertingArticle] = useState(false);

  const [data, setData] = useState([]);
  const [cashRegister, setCashRegister] = useState([]);

  // const [clients, setClients] = useState([]);
  //   const [suppliers, setSuppliers] = useState([]);
  const [suppliersDetails, setSuppliersDetails] = useState([]);

  // const [filteredClients, setFilteredClients] = useState([]);
  // const [clientsDetails, setClientsDetails] = useState([]);

  //   const [articles, setArticles] = useState([]);
  // const [filteredArticles, setFilteredArticles] = useState([]);

  const [valuedetails, setValueDetails] = useState([]);

  // Te dhenat per printim
  const [headerData, setHeaderData] = useState([]);
  const [companiesData, setCompaniesData] = useState([]);
  const [articlePrintDetails, setArticlePrintDetails] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);

  const [companyName, setCompanyName] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyID, setcompanyID] = useState("");
  const [articleInventory, setArticleInventory] = useState([]);
  const [showInventoryAlert, setShowInventoryAlert] = useState(false);

  const [form1IsDisabled, setForm1IsDisabled] = useState(false);
  const [form2IsDisabled, setForm2IsDisabled] = useState(true);

  const [hasElectronicSeal, setHasElectronicSeal] = useState(null);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleEnable = () => {
    setForm1IsDisabled(true);
    setForm2IsDisabled(false);
  };

  //Kodi ka detyr qe nese lloji i transaksionit eshte eksport ose sherbim jasht vendit, ta vendos VAT 0%
  useEffect(() => {
    if (
      transactionsType == 2 ||
      transactionsType == 3 ||
      transactionsType == 4
    ) {
      setVATRates(0);
    }
  });

  const newInvoice = () => {
    const currentDate = new Date();
    // const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${fiscalYear}-${month}-${day}`;

    setForm1IsDisabled(false);
    setForm2IsDisabled(true);
    setOpenDetails(false);
    setArticleID();
    setQtyOutput(0);
    setDiscountPercent(0);
    setPriceWithoutVAT(0);
    setPriceWithVAT(0);
    setTotal(0);
    fetchLastInvoiceNr(fiscalYear);
    setDate(formattedDate);
    setPayDate(formattedDate);
    setComent("");
    setTransactionType(1);
    setPaymentOptions("");
    setSupplierID("");
    setClientBranchID("");
    setHasClientBranch(false);
    setClientBranchField(null);
    // setClientName("");
    setSuppliersDetails([]);
    setData([]);
    setValueDetails([]);
    setField(null);
    setAccfield(null);
    setShowInventoryAlert(false);
    setArticleInventory([]);
  };

  // kodi per dergimin e emailit
  const [clientEmail, setClientEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [uInvoiceNr, setUInvoiceNr] = useState("");
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false);

  useEffect(() => {
    if (invoiceNR) {
      let Sb = lang == "en" ? "Invoice number:" : "Fatura me numër:";
      setSubject(invoiceNR);
    }
  }, [invoiceNR, lang, fiscalYear]);

  // keto konstante sherbejn per ta mbajtur gjendjen e formave nese jane hide ose jo
  const [showEditForm, setShowEditForm] = useState(false);
  const [showInserForm, setShowInsertForm] = useState(true);
  // ky kod i ndryshon gjendjet e formave

  const handleOpenForm2 = () => {
    setShowInsertForm(true);
    setShowEditForm(false); // I fsheh formën e parë
    setArticleID();
    setQtyOutput(0);
    setDiscountPercent(0);
    setPriceWithoutVAT(0);
    setPriceWithVAT(0);
    setTotal(0);
  };
  const handleOpenForm1 = () => {
    setShowInsertForm(false);
    setShowEditForm(true); // I fsheh formën e parë
  };

  const handleEditDetails = (item) => {
    handleOpenForm1();
    fetchArticlesSalesPrice(item.ArticleID, "getVat");
    setFormDetailData({
      HistoryID: item.HistoryID,
      ArticleID: item.ArticleID,
      QtyOutput: item.QtyOutput,
      DiscountPercent: item.DiscountPercent,
      PriceBeforeDiscount: item.PriceBeforeDiscount,
      Total: item.Total,
      PriceWithVAT: item.PriceWithVAT,
      PriceWithoutVAT: item.PriceWithoutVAT,
      ModifiedByUser: logedEmail,
      InvoiceNr: invoiceNR,
      PaymentOptions: paymentOptions,
    });
  };

  const clearEdit = () => {
    setFormDetailData({
      HistoryID: "",
      ArticleID: "",
      QtyOutput: 0,
      PriceWithVAT: 0,
      PriceWithoutVAT: 0,
      setFormDetailData: 0,
    });

    clearLine();
    handleOpenForm2();
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      setLogedEmail(decodedToken.email);
    }
  }, []);

  // const fetchLastInvoiceNr = async (fiscalY) => {
  //     try {
  //         const response = await axios.get(ApiLink.API_URL + 'ReturnToSupplier/InvoiceNr', { headers, params: { fiscalYear: fiscalY } });
  //         setInvoiceNR(response.data.NextInvoiceNr);
  //     } catch (error) {
  //         errorAlert("Gabim në kërkesë:", error);
  //         if (error.response && error.response.data && error.response.data.errorMessage) {
  //             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
  //         } else if (error.message) {
  //             errorAlert(`Gabim: ${error.message}`);
  //         } else {
  //             errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //         }
  //     }
  // };

  const fetchUnId = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "UserDetails/GetUnitIDByUserID",
        { headers },
      );
      // console.log(response.data);
      setUnID(response.data.CompanyUnit_ID);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ReturnToSupplier/returnDetails",
        { headers, params: { invNumber: invoiceNR, fiscalYear: fiscalYear } },
      );
      setData(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };
  const fetchArticleInventory = async (articleID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "AccountingBooks/inventoryByArticleID",
        { headers, params: { articleID: articleID, fiscalYear: fiscalYear } },
      );
      setArticleInventory(response.data);
      // console.log(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  // const fetchClientBranch = async (clientID) => {
  //     try {
  //         const response = await axios.get(ApiLink.API_URL + 'ClientBranches/clientBranchFilterByAccountID', { headers, params: { accountID: clientID } });
  //         setClientBranch(response.data);
  //         if (response.data.length > 0) {
  //             setHasClientBranch(true);
  //         }
  //         else {
  //             setHasClientBranch(false);
  //         }
  //     } catch (error) {
  //         errorAlert("Gabim në kërkesë:", error);
  //         if (error.response && error.response.data && error.response.data.errorMessage) {
  //             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
  //         } else if (error.message) {
  //             errorAlert(`Gabim: ${error.message}`);
  //         } else {
  //             errorAlert("Gabim i panjohur në kërkesë");
  //         }
  //     }
  // };

  const fetchTransactionID = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ReturnToSupplier/GetTransactionID",
        {
          headers,
          params: {
            email: logedEmail,
            invNumber: invoiceNR,
            fiscalYear: fiscalYear,
          },
        },
      );
      setDeleteTransactionID(response.data);
      // Kontrollo nëse nuk ka të dhëna të disponueshme
      if (response.data.length === 0) {
        // Shfaqi një mesazh për përdoruesin
        // errorAlert("No data available.");
      }
    } catch (error) {
      // console.log(error);
      // Shfaqi një mesazh për përdoruesin për gabimin e tjera
      // setMessage("Error: Failed to fetch data.");
    }
  };

  const fetchHeaderData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ReturnToSupplier/GetPrintHeaderDetails",
        {
          headers,
          params: {
            invNumber: invoiceNR,
            actionType: "DND",
            fiscalYear: fiscalYear,
          },
        },
      );
      setHeaderData(response.data);
      setUInvoiceNr(response.data[0].TransactionUID);
      setLink(
        encodeURI(
          `http://acctree.net/invoice?invoiceNR=${response.data[0].TransactionUID}`,
        ),
      );
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchArticleDataPrint = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetArticleDetailsForPrint",
        {
          headers,
          params: {
            invNumber: invoiceNR,
            actionType: "DND",
            fiscalYear: fiscalYear,
          },
        },
      );
      setArticlePrintDetails(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchBanksAccount = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/BankDetails",
        { headers },
      );
      setBankAccounts(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };
  const fetchCompaniesData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Companies/getCompanyDetails",
        { headers },
      );
      setCompaniesData(response.data);
      setCompanyName(response.data[0].CompanyName);
      setCompanyEmail(response.data[0].Email);
      setcompanyID(response.data[0].CompanyID);
      setHasElectronicSeal(response.data[0].ElectronicSeal);
      // console.log(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const [totalWithDiscountAmount, setTotalWithDiscountAmount] = useState(0);

  const fetchvaluedetails = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ReturnToSupplier/getvaluedetails",
        { headers, params: { invNumber: invoiceNR, fiscalYear: fiscalYear } },
      );
      setValueDetails(response.data);
      setDiscountAmount(response.data[0].DiscountAmount);
      setTotalWithDiscountAmount(
        response.data[0].Total + response.data[0].DiscountAmount,
      );
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const calculatePercent = (value) => {
    setPerqindjaZbritjes((value / totalWithDiscountAmount) * 100);
  };

  const fetchPaymentType = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/paymenttype",
        { headers },
      );
      setCashRegister(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë");
      }
    }
  };

  //   const fetchSuppliers = async () => {
  //     try {
  //       const response = await axios.get(
  //         ApiLink.API_URL + "Accounts/accountByLedger",
  //         { headers, params: { ledger: 302 } },
  //       );
  //       setSuppliers(response.data);
  //     } catch (error) {
  //       errorAlert("Gabim në kërkesë:", error);
  //       if (
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.errorMessage
  //       ) {
  //         errorAlert(
  //           `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
  //         );
  //       } else if (error.message) {
  //         errorAlert(`Gabim: ${error.message} `);
  //       } else {
  //         errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //       }
  //     }
  //   };

  const fetchSuppliersDetails = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByID",
        { headers, params: { id: supplierID } },
      );
      setSuppliersDetails(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  //   const fetchArticles = async () => {
  //     try {
  //       const response = await axios.get(ApiLink.API_URL + "Article", {
  //         headers,
  //       });
  //       setArticles(response.data);
  //     } catch (error) {
  //       errorAlert("Gabim në kërkesë:", error);
  //       if (
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.errorMessage
  //       ) {
  //         errorAlert(
  //           `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
  //         );
  //       } else if (error.message) {
  //         errorAlert(`Gabim: ${error.message}`);
  //       } else {
  //         errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //       }
  //     }
  //   };

  const [buttonContent, setButtonContent] = useState({
    text: "Hap Detalet e Faturës",
    backgroundColor: "#4E7B67",
    transcation: "background-color 0.3s ease",
    onMouseEnter: "#284945",
    onMouseLeave: "#4E7B67",
  });
  const [invNumberExist, setInvNumberExist] = useState();
  const checkInvoiceNumber = async (invoiceNR) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ReturnToSupplier/invoiceExists",
        { headers, params: { invNumber: invoiceNR, fiscalYear: fiscalYear } },
      );
      setInvNumberExist(response.data[0].InvoiceCount);
      if (response.data[0].InvoiceCount > 0) {
        setButtonContent({
          text: "Numri i faturës ekziston në listë",
          backgroundColor: "red",
          transcation: "background-color 0.3s red",
          onMouseEnter: "red",
          onMouseLeave: "red",
        });
      } else {
        setButtonContent({
          text: "Hap Detalet e Faturës",
          backgroundColor: "#4E7B67",
          transcation: "background-color 0.3s ease",
          onMouseEnter: "#284945",
          onMouseLeave: "#4E7B67",
        });
      }
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchArticlesSalesPrice = async (articleID, form) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetSalesPrice",
        { headers, params: { articleID: articleID } },
      );
      const salesPriceData = response.data; // Merr të dy vlerat e "SalesPrice" dhe "VATRates" nga përgjigja

      if (form == "edit") {
        const calculatedValue =
          (parseFloat(response.data.PurchasePrice) * 100) /
          (100 + response.data.SalesPrice);
        // setInsertPriceWithoutVAT(calculatedValue.toFixed(2));
        setVATRates(response.data.VATRates);
        // setTempPriceWithVAT(salesPriceData.SalesPrice);
        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: response.data.PurchasePrice,
          PriceWithoutVAT: calculatedValue,
          DiscountPercent: 0,
          // QtyOutput: 1,
          PriceBeforeDiscount: response.data.PurchasePrice,
          // Total: 1 * response.data.PurchasePrice,
          Total: formDetailData.QtyInput * response.data.PurchasePrice,
        }));
      } else if (form == "getVat") {
        setVATRates(response.data.VATRates);
        // alert("get vat" + vatRates)
      } else {
        setPriceWithVAT(salesPriceData.PurchasePrice);
        setTempPriceWithVAT(salesPriceData.PurchasePrice);
        setVATRates(salesPriceData.VATRates);
        setQtyOutput(1);
        // Kalkulimi i vlerës pa TVSH dhe vendosja e saj tek PriceWithoutVAT
        const calculatedValue =
          (parseFloat(salesPriceData.PurchasePrice) * 100) /
          (100 + salesPriceData.VATRates);
        setPriceWithoutVAT(calculatedValue.toFixed(2));
        setTotal(1 * salesPriceData.PurchasePrice);
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchLastInvoiceNr = async (fiscalY) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ReturnToSupplier/InvoiceNr",
        { headers, params: { fiscalYear: fiscalY } },
      );
      setInvoiceNR(response.data.NextInvoiceNr);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const handleDelete = async (deleteItemId) => {
    try {
      // const response =
      await axios.delete(
        ApiLink.API_URL + "ReturnToSupplier/oneline" + `/${deleteItemId}`,
        {
          headers,
          params: {
            email: logedEmail,
            invoiceNR: invoiceNR,
            fiscalYear: fiscalYear,
          },
        },
      );
      deleteAlert("Purchase detail deleted Successfully");

      fetchData();
      fetchvaluedetails();
      fetchHeaderData();
      fetchArticleDataPrint();
    } catch (error) {
      deleteAlert("Purchase detail can not be deleted");
    }
  };

  // Kodi per fshirjen e nje elementi ne databaz
  const handleDeleteTransactionID = async () => {
    try {
      // const response =
      await axios.delete(
        ApiLink.API_URL + "ReturnToSupplier" + `/${deleteTransactionID}`,
        { headers },
      );
      setShowDeleteTransactionID(false);
      deleteAlert("Shitja është fshirë me sukses");
      setShowInventoryAlert(false);
      setArticleInventory([]);
      history.push("/Sales/salesindetails"); // Zëvendëso 'your-desired-path' me path-in e dëshiruar
    } catch (error) {
      deleteAlert("Shitja nuk është fshirë");
    }
  };
  const [link, setLink] = useState("");

  const [sendingEmail, setSendingEmail] = useState(false);

  const sendEmail = (event, lang) => {
    event.preventDefault();
    setSendingEmail(true); // Ndryshoni gjendjen e progresit në fillim të dërgimit të emailit

    if (clientEmail === "" || clientEmail == null) {
      errorAlert(
        "Emaili nuk mund te dergohet, sepse klienti nuk ka email te regjistruar",
      );
      setSendingEmail(false);
      return;
    }
    if (uInvoiceNr === "" || uInvoiceNr == null) {
      errorAlert(
        "Fatura nuk mund te dergohet sepse, ende nuk e keni ruajtur faturen ne databaz",
      );
      setSendingEmail(false);
      return;
    }

    // Përdor parametrin 'lang' për gjuhën
    const newInvoiceURL = encodeURI(
      `http://acctree.net/invoice?invoiceNR=${uInvoiceNr}&lang=${lang}`,
    );
    // const newInvoiceURL = encodeURI(`http://localhost:3000/invoice?invoiceNR=${uInvoiceNr}&lang=${lang}`);
    // Përmbajtja e emailit për shqip
    const emailBodySQ = `Të nderuar,
    
        Dëshirojmë t'ju njoftojmë se fatura elektronike është krijuar me sukses dhe është gati për shkarkim. Për të marrë faturën tuaj, ju lutem klikoni në linkun e mëposhtëm: ${newInvoiceURL}.
    
        Ju lutëm të kryeni pagesën e faturës në njëren nga llogaritë e ${companyName} që janë specifikuar në faturë.
    
        Për çdo pyetje apo ndihmë shtesë, mos ngurroni të na kontaktoni në adresen elektronike: ${companyEmail}
    
        Me respekt,
        ${companyName}`;

    // Përmbajtja e emailit për anglisht
    const emailBodyEN = `Dear Sir/Madam,
    
        We would like to inform you that the electronic invoice has been successfully created and is ready for download. To access your invoice, please click on the following link: ${newInvoiceURL}.
    
        Please make the payment to one of ${companyName}'s bank accounts specified in the invoice.
    
        For any questions or further assistance, feel free to contact us at: ${companyEmail}
    
        Best regards,
        ${companyName}`;

    // Zgjidh përmbajtjen e emailit sipas gjuhës
    const emailBody = lang === "en" ? emailBodyEN : emailBodySQ;

    const data = {
      To: clientEmail,
      Subject: subject,
      Body: emailBody, // Përdor emailBody bazuar në gjuhën e zgjedhur
    };

    axios
      .post(ApiLink.API_URL + "Gmail", data, { headers })
      .then(() => {
        handleSuccess("Email sent successfully");
        setShowEmailConfirmation(false);
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert("An unknown error occurred while processing the request.");
          setSendingEmail(false);
        }
      })
      .finally(() => {
        setSendingEmail(false); // Përfundimi i dërgimit të emailit, ndryshoni gjendjen e progresit
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setInsertingTransaction(true);
    if (!invoiceNR) {
      errorAlert("Ju lutem plotësoni numrin e faturës!");
      setInsertingTransaction(false);
      return;
    }
    if (!date) {
      errorAlert("Ju lutem plotësoni Daten!");
      setInsertingTransaction(false);
      return;
    }
    if (!paymentOptions) {
      errorAlert("Ju lutem plotësoni mënyren e pagesës!");
      setInsertingTransaction(false);
      return;
    }
    if (!supplierID) {
      errorAlert("Ju lutem plotësoni klientin!");
      setInsertingTransaction(false);
      return;
    }
    if (paymentOptions != 0 && payDate == "") {
      errorAlert("Ju lutem plotësoni Daten e pagesës!");
      setInsertingTransaction(false);
      return;
    }

    const stateDate = {
      Date: date,
      PayDate: paymentOptions !== 0 ? payDate : null,
      InvoiceNr: invoiceNR,
      SupplierID: supplierID,
      TransactionType: transactionsType,
      ActionType: "DND",
      PaymentOptions: paymentOptions,
      CompanyUnitID: unId > 0 ? unId : null,
      ClientBranchID: clientBranchID > 0 ? clientBranchID : null,
      Coment: coment,
      CreatedByUser: email,
    };
    axios
      .post(ApiLink.API_URL + "ReturnToSupplier/invoicedetail", stateDate, {
        headers,
      })
      .then(() => {
        // handleSuccess("Sales Invoice Added Successfully");
        handleEnable();
        setOpenDetails(true);
        fetchHeaderData();
        fetchTransactionID();
        setInsertingTransaction(false);
      })
      .catch((error) => {
        // console.error(error);
        setInsertingTransaction(false);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
          setInsertingTransaction(false);
        } else {
          errorAlert("An unknown error occurred while processing the request.");
          setInsertingTransaction(false);
        }
      })
      .finally(() => {
        setInsertingTransaction(false);
      });
  };

  const handleNewSubmit = (event) => {
    event.preventDefault();
    setInsertingArticle(true);
    if (!invoiceNR) {
      errorAlert("Ju lutem plotësoni numrin e faturës!");
      setInsertingArticle(false);
      return;
    }
    if (!articleID) {
      errorAlert("Ju lutem plotësoni artikullin");
      setInsertingArticle(false);
      return;
    }
    // Shtoni kontrollet këtu
    if (isNaN(qtyOutput)) {
      errorAlert("Sasia e produkteve (qtyOutput) duhet të jetë një numër.");
      setInsertingArticle(false);
      return;
    }
    if (isNaN(priceWithoutVAT)) {
      errorAlert("Çmimi pa TVSH (priceWithoutVAT) duhet të jetë një numër.");
      setInsertingArticle(false);
      return;
    }
    if (isNaN(priceWithVAT)) {
      errorAlert("Çmimi me TVSH (priceWithVAT) duhet të jetë një numër.");
      setInsertingArticle(false);
      return;
    }
    if (isNaN(total)) {
      errorAlert("Totali duhet të jetë një numër.");
      setInsertingArticle(false);
      return;
    }
    const stateDate = {
      InvoiceNr: invoiceNR,
      ArticleID: articleID,
      QtyOutput: qtyOutput,
      DiscountPercent: discountPercent,
      PriceBeforeDiscount: tempPriceWithVAT,
      PriceWithoutVAT: priceWithoutVAT,
      PriceWithVAT: priceWithVAT,
      CompanyUnitID: unId > 0 ? unId : null,
      CreatedByUser: email,
      Date: date,
      SupplierID: supplierID,
    };
    axios
      .post(ApiLink.API_URL + "ReturnToSupplier/createnewline", stateDate, {
        headers,
        params: { vatRates: vatRates },
      })
      .then(() => {
        // handleSuccess("Detail  Added Successfully");
        setArticleID();
        setQtyOutput(0);
        setDiscountPercent(0);
        setPriceWithoutVAT(0);
        setPriceWithVAT(0);
        setTotal(0);
        fetchvaluedetails();
        fetchHeaderData();
        fetchArticleDataPrint();
        // setArticlesName("");
        fetchData();
        setDiscountPercent(0);
        setTempPriceWithVAT(0);
        setInsertingArticle(false);
        setField(null);
        setShowInventoryAlert(false);
        setArticleInventory([]);
      })
      .catch((error) => {
        console.error(error);
        setInsertingArticle(false);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
          setInsertingArticle(false);
        } else {
          errorAlert("An unknown error occurred while processing the request.");
          setInsertingArticle(false);
        }
      })
      .finally(() => {
        setInsertingArticle(false);
      });
  };
  // const [detailLine, setDetailLine] = useState([]); //i mban rreshtat e te dhenave detale
  const [formDetailData, setFormDetailData] = useState({
    HistoryID: "",
    ArticleID: "",
    QtyOutput: "",
    DiscountPercent: "",
    PriceBeforeDiscount: "",
    Total: "",
    PriceWithVAT: "",
    PriceWithoutVAT: "",
    ModifiedByUser: "",
    InvoiceNr: "",
    PaymentOptions: "",
  });

  // Kodi per ruajtjen e te dhenave pas editimint
  const handleInputChangeDetail = (event) => {
    const { name, value } = event.target;
    setFormDetailData({ ...formDetailData, [name]: value });
  };

  const handleSubmitDetailLine = (event) => {
    event.preventDefault();
    axios
      .put(
        ApiLink.API_URL + "ReturnToSupplier/updatedetailsArticle",
        formDetailData,
        { headers, params: { vatRates: vatRates, fiscalYear: fiscalYear } },
      )
      .then((response) => {
        // fetchDetailLineData(invoiceNR);
        fetchvaluedetails();
        // updateAlert("Detail updated successfully");
        fetchArticleDataPrint();
        fetchHeaderData();
        fetchData();
        handleOpenForm2();
      })
      .catch((error) => {
        // console.log(error);
        errorAlert("Failed to update details");
      });
  };

  const constUpdateDiscountAmount = (event) => {
    event.preventDefault();
    axios
      .put(
        `${ApiLink.API_URL}ReturnToSupplier/aplikoZbritjen?companyID=${companyID}&invoiceNr=${invoiceNR}&percent=${perqindjaZbritjes}&fiscalYear=${fiscalYear}`,
        {},
        { headers },
      )
      .then((response) => {
        fetchvaluedetails();
        fetchArticleDataPrint();
        fetchHeaderData();
        fetchData();
      })
      .catch((error) => {
        // console.log(error);
        errorAlert(error);
      });
  };

  const clearLine = () => {
    setArticleID();
    setQtyOutput(0);
    setPriceWithoutVAT(0);
    setPriceWithVAT(0);
    setTotal(0);
    fetchData();
    fetchvaluedetails();
    fetchHeaderData();
    fetchArticleDataPrint();
    // setArticlesName("");
    setDiscountPercent(0);
    setTempPriceWithVAT(0);
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleTextFieldWidth = () => {
    return screenWidth <= 450 ? "100%" : "41ch";
  };
  const handleCalculatePriceWithVAT = async (type) => {
    try {
      if (isNaN(priceWithoutVAT)) {
        throw new Error(
          "Çmimi pa TVSH (priceWithoutVAT) duhet të jetë një numër.",
        );
      }

      if (isNaN(qtyOutput)) {
        throw new Error(
          "Sasia e produkteve (qtyOutput) duhet të jetë një numër.",
        );
      }
      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const vat =
          Number(formDetailData.PriceWithoutVAT) * (Number(vatRates) / 100);
        const calculatedPriceWithVAT =
          Number(formDetailData.PriceWithoutVAT) + vat;
        const total = Number(formDetailData.QtyOutput) * calculatedPriceWithVAT;

        setTempPriceWithVAT(
          Number(calculatedPriceWithVAT) /
            (1 - Number(formDetailData.DiscountPercent) / 100),
        );

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: calculatedPriceWithVAT,
          Total: total,
          PriceBeforeDiscount: tempPriceWithVAT,
        }));
      } else {
        const vat = Number(priceWithoutVAT) * (Number(vatRates) / 100);
        const calculatedPriceWithVAT = Number(priceWithoutVAT) + vat;
        const total = Number(qtyOutput) * calculatedPriceWithVAT;
        // Veprimet specifike për shtim të ri
        setPriceWithVAT(calculatedPriceWithVAT);
        setTotal(total);

        setTempPriceWithVAT(
          Number(calculatedPriceWithVAT) / (1 - Number(discountPercent) / 100),
        );
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  const handleCalculatePriceWithoutVAT = async (type) => {
    try {
      if (isNaN(priceWithVAT)) {
        throw new Error(
          "Çmimi me TVSH (priceWithVAT) duhet të jetë një numër.",
        );
      }

      if (isNaN(qtyOutput)) {
        throw new Error(
          "Sasia e produkteve (qtyOutput) duhet të jetë një numër.",
        );
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const calculatedPriceWithoutVAT =
          (Number(formDetailData.PriceWithVAT) * 100) /
          (100 + Number(vatRates));
        const total =
          Number(formDetailData.QtyOutput) *
          Number(formDetailData.PriceWithVAT);
        setTempPriceWithVAT(
          Number(formDetailData.PriceWithVAT) /
            (1 - Number(formDetailData.DiscountPercent) / 100),
        );

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          Total: total,
          PriceBeforeDiscount: tempPriceWithVAT,
        }));
      } else {
        setTempPriceWithVAT(
          Number(priceWithVAT) / (1 - Number(discountPercent) / 100),
        );

        // Veprimet specifike për shtim të ri
        const calculatedPriceWithoutVAT =
          (Number(priceWithVAT) * 100) / (100 + Number(vatRates));
        const total = Number(qtyOutput) * Number(priceWithVAT);

        setPriceWithoutVAT(calculatedPriceWithoutVAT);
        setTotal(total);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  const handleCalculatePrices = async (type) => {
    try {
      if (isNaN(qtyOutput)) {
        throw new Error(
          "Sasia e produkteve (qtyOutput) duhet të jetë një numër.",
        );
      }

      if (isNaN(total)) {
        throw new Error("Totali duhet të jetë një numër.");
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const priceWithVAT =
          Number(formDetailData.Total) / Number(formDetailData.QtyOutput);
        // const calculatedPriceWithoutVAT = formDetailData.PriceWithVAT * 100 / (100 + Number(vatRates));
        const calculatedPriceWithoutVAT =
          (priceWithVAT * 100) / (100 + Number(vatRates));
        // setTempPriceWithVAT(Number(formDetailData.PriceWithVAT) / (1 - (Number(formDetailData.DiscountPercent) / 100)))
        const tempPriceWithVATEdit =
          Number(priceWithVAT) /
          (1 - Number(formDetailData.DiscountPercent) / 100.0);

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: priceWithVAT,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          PriceBeforeDiscount: tempPriceWithVATEdit,
        }));
      } else {
        // Veprimet specifike për shtim të ri
        const priceWithVAT = Number(total) / Number(qtyOutput);
        const calculatedPriceWithoutVAT =
          (priceWithVAT * 100) / (100 + Number(vatRates));

        setTempPriceWithVAT(
          Number(priceWithVAT) / (1 - Number(discountPercent) / 100),
        );

        setPriceWithoutVAT(calculatedPriceWithoutVAT);
        setPriceWithVAT(priceWithVAT);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  const handleCalculatePriceWithRabat = async (type) => {
    try {
      if (isNaN(discountPercent)) {
        throw new Error("% e rabatit (Rabati) duhet të jetë një numër.");
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        setTempPriceWithVAT(formDetailData.PriceBeforeDiscount);

        const vleraZbritjes =
          tempPriceWithVAT * (formDetailData.DiscountPercent / 100);
        const priceWithVATRabat =
          Number(tempPriceWithVAT) - Number(vleraZbritjes);

        const calculatedPriceWithoutVAT =
          (Number(priceWithVATRabat) * 100) / (100 + Number(vatRates));
        const total =
          Number(formDetailData.QtyOutput) * Number(priceWithVATRabat);

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          PriceWithVAT: priceWithVATRabat,
          Total: total,
          PriceBeforeDiscount: tempPriceWithVAT,
        }));
      } else {
        // Veprimet specifike për shtim të ri
        const vleraZbritjes = tempPriceWithVAT * (discountPercent / 100);
        const priceWithVATRabat =
          Number(tempPriceWithVAT) - Number(vleraZbritjes);

        const calculatedPriceWithoutVAT =
          (Number(priceWithVATRabat) * 100) / (100 + Number(vatRates));
        const total = Number(qtyOutput) * Number(priceWithVATRabat);

        setPriceWithoutVAT(calculatedPriceWithoutVAT);
        setPriceWithVAT(priceWithVATRabat);
        setTotal(total);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  useEffect(() => {
    // Kontrollo nqs clientID është ndryshuar para se të kryhen veprimet
    if (supplierID !== "") {
      fetchSuppliersDetails(supplierID);
    }
  }, [supplierID]);

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    if (fiscalYear === year) {
      setDate(formattedDate);
      setPayDate(formattedDate);
    } else {
      setDate("");
      setPayDate("");
    }
  }, [fiscalYear]);

  const calculateAndSetPaymentDate = (pay) => {
    // Supozojmë që 'date' është një objekt i vlefshëm Date.
    // Nëse jo, duhet të krijohet si i tillë.
    let paymentDate = new Date(date); // Kjo siguron që paymentDate të jetë një objekt Date.

    if (pay === "0") {
      // Shtojmë 5 ditë nëse paymentOptions është "0"
      paymentDate.setDate(paymentDate.getDate() + 5); // Përdor getDate() për të marrë ditën dhe pastaj shto 5
      const formattedDate = paymentDate.toISOString().split("T")[0];
      setPayDate(formattedDate);
    } else {
      // Supozojmë që 'date' është formatuar siç duhet
      setPayDate(date);
    }
  };

  //Pjesa per select input field Clients
  // const [accField, setAccfield] = useState(null)
  // const handleAutocompleteChangeClient = (event, value) => {
  //     if (value && value.AccountID) {
  //         setClientID(value.AccountID);
  //         setAccfield(value);
  //         fetchLastInvoiceNr(fiscalYear);
  //         fetchClientBranch(value.AccountID);

  //     } else {
  //         // Në rast se vlera është pastruar
  //         setClientID(""); // Vendos vlerën e ArticleID në null
  //     }
  // };

  const [accField, setAccfield] = useState(null);
  //Pjesa per select input field supplier
  //   const handleAutocompleteChangeSuppliers = (event, value) => {
  //     if (value && value.AccountID) {
  //       setSupplierID(value.AccountID);
  //       setAccfield(value);
  //       fetchLastInvoiceNr(fiscalYear);
  //     } else {
  //       // Në rast se vlera është pastruar
  //       setSupplierID(""); // Vendos vlerën e ArticleID në null
  //     }
  //   };
  //   const defaultPropsSuppliers = {
  //     options: suppliers,
  //     getOptionLabel: (option) =>
  //       `${option.IdentificationNumber} - ${option.AccountName}` || "",
  //     renderOption: (props, option) => (
  //       <>
  //         <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //           <span>
  //             {option.IdentificationNumber}
  //             <br />
  //             {option.AccountName}
  //           </span>
  //         </li>
  //       </>
  //     ),
  //   };

  // const defaultPropsClients = {
  //     options: clients,
  //     getOptionLabel: (option) =>
  //         `${option.IdentificationNumber} - ${option.AccountName}` || "",
  //     renderOption: (props, option) => (
  //         <>
  //             <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //                 <span>
  //                     {option.IdentificationNumber}<br />
  //                     {option.AccountName}
  //                 </span>
  //             </li>
  //         </>
  //     ),
  // };

  //Pjesa per select input field Clients
  const [clientBranchField, setClientBranchField] = useState(null);
  const handleAutocompleteChangeClientBranch = (event, value) => {
    if (value && value.ClientBranchID) {
      setClientBranchID(value.ClientBranchID);
      setClientBranchField(value);
    } else {
      // Në rast se vlera është pastruar
      setClientBranchID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsClientBranch = {
    options: clientBranch,
    getOptionLabel: (option) =>
      `${option.ClientBranchName} - ${option.ClientBranchAddress}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            <b> {option.ClientBranchName}</b>
            <br />
            {option.ClientBranchAddress}
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field Article
  const [field, setField] = useState(null);
  //   const handleAutocompleteChangeArticle = async (event, value) => {
  //     if (value && value.ArticleID) {
  //       setArticleID(value.ArticleID);

  //       // Ekzekutoni funksionet njëra pas tjetrës
  //       await fetchArticlesSalesPrice(value.ArticleID);
  //       await fetchArticleInventory(value.ArticleID);
  //       setField(value); // Nuk ka nevojë për 'await' nëse nuk është një funksion asinkron

  //       // Vendosni alertin pasi të përfundohen të gjitha funksionet e mësipërme
  //       setShowInventoryAlert(true);
  //     } else {
  //       // Në rast se vlera është pastruar
  //       setArticleID("");
  //       setField(null);
  //     }
  //   };

  //   const defaultPropsArticle = {
  //     options: articles,
  //     getOptionLabel: (option) =>
  //       `${option.Barcode} - ${option.ArticleName}` || "",
  //     renderOption: (props, option) => (
  //       <>
  //         <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //           <span>
  //             {option.Barcode}
  //             <br />
  //             {option.ArticleName}
  //           </span>
  //           <label style={{ marginLeft: "auto", fontWeight: "bold" }}>
  //             {option.PurchasePrice !== null && option.PurchasePrice !== 0
  //               ? option.PurchasePrice.toLocaleString("en-US", {
  //                   minimumFractionDigits: 2,
  //                 })
  //               : "0.00"}
  //             €
  //           </label>
  //         </li>
  //       </>
  //     ),
  //   };

  ////////////////////////

  //   const handleAutocompleteChangeArticleEdit = (event, value) => {
  //     if (value) {
  //       setFormDetailData((prevState) => ({
  //         ...prevState,
  //         ArticleID: value.ArticleID,
  //       }));
  //       fetchArticlesSalesPrice(value.ArticleID, "edit");
  //     } else {
  //       setFormDetailData((prevState) => ({
  //         ...prevState,
  //         ArticleID: "",
  //       }));
  //     }
  //   };

  //   const defaultPropsArticleEdit = {
  //     options: articles,
  //     getOptionLabel: (option) =>
  //       `${option.Barcode} - ${option.ArticleName}` || "",
  //     renderOption: (props, option) => (
  //       <>
  //         <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //           <span>
  //             {option.Barcode}
  //             <br />
  //             {option.ArticleName}
  //           </span>
  //           <label style={{ marginLeft: "auto", fontWeight: "bold" }}>
  //             {/* {option.SalesPrice}€ */}
  //             {option.PurchasePrice !== null && option.PurchasePrice !== 0
  //               ? option.PurchasePrice.toLocaleString("en-US", {
  //                   minimumFractionDigits: 2,
  //                 })
  //               : "0.00"}
  //             €
  //           </label>
  //           {/* <button
  //                         onClick={(e) => {
  //                             e.stopPropagation();
  //                             // handleButtonClick(option);
  //                         }}
  //                         style={{ marginLeft: 'auto' }}
  //                     >
  //                         click me
  //                     </button> */}
  //         </li>
  //       </>
  //     ),
  //   };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      let nextField;
      switch (e.target.id) {
        case "ArticleID":
          nextField = document.getElementById("QtyOutput");
          break;
        case "QtyOutput":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "PriceWithoutVAT":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "PriceWithVAT":
          nextField = document.getElementById("Total");
          break;
        case "DiscountPercent":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "Total":
          if (showEditForm === true && showInserForm === false) {
            handleSubmitDetailLine(e);
          } else if (showInserForm === true && showEditForm === false) {
            handleNewSubmit(e);
          }
          nextField = document.getElementById("ArticleID");
          break;
        default:
          return;
      }
      if (nextField && nextField.select) {
        nextField.focus();
        nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
      }
    }
  };

  const ShowArticleInventoryAlert = () => {
    const article = articleInventory[0] ? articleInventory[0] : 0;
    const totalQtyInStock = article.TotalQtyInStock ?? 0;
    const articlePositive = `Artikulli: ${article.ArticleName}, Sasia në stok: ${totalQtyInStock}`;
    const articleName = article.ArticleName ? (
      <Alert severity="error">
        Artikulli: {article.ArticleName}, nuk ka sasi në stok, Sasia:
        {totalQtyInStock}
      </Alert>
    ) : (
      <Alert severity="warning">Ky artikull nuk ka histori</Alert>
    );

    return (
      <>
        {totalQtyInStock > 0 ? (
          <Alert severity="success">{articlePositive}</Alert>
        ) : (
          <>{articleName}</>
        )}
      </>
    );
  };

  const rows = data.map((item, index) => ({
    id: ++index,
    article: item.ArticleName,
    qty: item.QtyOutput,
    PBD: item.PriceWithoutVATBeforeDiscount,
    discount: item.DiscountPercent,
    PNoVAT: item.PriceWithoutVAT,
    PVAT: item.PriceWithVAT,
    amountNoVAT: item.Amount,
    vat: item.VAT,
    amountVAT: item.Total,
    rowInfo: item,
    deleteItemId: item.HistoryID,
  }));

  // // Funksioni për të gjeneruar përmbajtjen e file-it .txt
  // const generateReceiptContent = (data) => {
  //     let fileContent = "";
  //     fileContent += `Q,1,______,_,__;1;Fatura: CND-${fiscalYear}-${invoiceNR}\n`;
  //     fileContent += `Q,1,______,_,__;2;Arkatari:${logedEmail}\n`;

  //     data.map((item, index) => {
  //         fileContent += `S,1,______,_,__;${item.ArticleName};${item.PriceWithVAT};${item.QtyOutput};1;1;${(item.VATRates == 18) ? 5 : (item.VATRates == 8) ? 4 : 1};${item.Barcode};${item.Barcode};\n`;
  //     });

  //     fileContent += "T,1,______,_,__;\n";

  //     return fileContent;
  // };

  // // Funksioni për të krijuar dhe shkarkuar file-in .txt
  // const downloadReceiptFile = (data) => {
  //     const fileContent = generateReceiptContent(data);
  //     const blob = new Blob([fileContent], { type: "text/plain;charset=utf-8" });
  //     saveAs(blob, `CND-${fiscalYear}-${invoiceNR}.inp`);
  // };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    fetchLastInvoiceNr(fiscalYear);
    fetchUnId();
  }, [fiscalYear]);

  useEffect(() => {
    // fetchSuppliers();
    // fetchArticles();
    fetchCompaniesData();
    fetchBanksAccount();
    fetchTransactionID();
    fetchPaymentType();
  }, [logedEmail, invoiceNR, supplierID, articleID]);
  return (
    <div className="SalesDetail__Container" style={{ paddingTop: "50px" }}>
      <Modal
        show={showDeleteTransactionID}
        onHide={() => setShowDeleteTransactionID(false)}
        style={{ marginTop: "150px" }}
      >
        <Modal.Header>
          <Modal.Title>Konfirmim</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>A jeni i sigurt që dëshironi ta fshini këtë faturë?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteTransactionID(false)}
          >
            JO
          </Button>
          <Button variant="danger" onClick={handleDeleteTransactionID}>
            PO
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showEmailConfirmation}
        onHide={() => setShowEmailConfirmation(false)}
        style={{ marginTop: "150px" }}
      >
        {/* <ProgressBar show={sendingEmail} /> */}
        <Modal.Header>
          <Modal.Title style={{ alignContent: "center" }}>
            Konfirmim
          </Modal.Title>
        </Modal.Header>
        {sendingEmail ? (
          <Modal.Body>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          </Modal.Body>
        ) : (
          <>
            <Modal.Body>
              {clientEmail && clientEmail ? (
                <p>A dëshironi ta dergoni faturën në këtë Email:</p>
              ) : (
                <p>Ju lutem shenoni emailin:</p>
              )}
              <TextField
                required
                style={{ width: "100%" }}
                id="clientEmail"
                label="Email-i i klientit"
                variant="outlined"
                type="text"
                name="clientEmail"
                value={clientEmail}
                onChange={(event) => setClientEmail(event.target.value)}
                autoComplete="off"
              />
              <hr></hr>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "start",
                }}
              >
                <div style={{ paddingTop: "10px" }}>
                  <label>Gjuha e fatures</label>
                </div>
                <div>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Language switcher"
                    style={{
                      display: "flex",
                      // marginRight: '20px', // Adds space between the language buttons and the "Anulo/Dërgo" buttons
                    }}
                  >
                    <Button
                      onClick={() => setLang("sq")}
                      style={{
                        backgroundColor:
                          lang === "sq" ? "#e3f2fd" : "transparent",
                        color: lang === "sq" ? "#1976d2" : "#6b6b6b",
                        borderColor: lang === "sq" ? "#1976d2" : "#d3d3d3",
                        borderRadius: "8px 0 0 8px", // Rounded corner on the left
                        padding: "6px 12px", // Reduced padding to make buttons smaller
                      }}
                    >
                      Shqip
                    </Button>
                    <Button
                      onClick={() => setLang("en")}
                      style={{
                        backgroundColor:
                          lang === "en" ? "#e3f2fd" : "transparent",
                        color: lang === "en" ? "#1976d2" : "#6b6b6b",
                        borderColor: lang === "en" ? "#1976d2" : "#d3d3d3",
                        borderRadius: "0 8px 8px 0", // Rounded corner on the right
                        padding: "6px 12px", // Reduced padding to make buttons smaller
                        marginLeft: "-2px", // Remove the gap between buttons
                      }}
                    >
                      English
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  variant="secondary"
                  onClick={() => setShowEmailConfirmation(false)}
                  style={{ marginRight: "10px" }}
                >
                  Anulo
                </Button>
                <Button
                  variant="danger"
                  onClick={(event) => sendEmail(event, lang)}
                >
                  Dërgo
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
      <br></br>
      <TitleElements
        icon={FaFileInvoice}
        title="Kthimi I Mallit tek Furnitori"
      />
      <ElementsParagraph text="Ju lutemi vini re se të gjitha te dhenat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!" />

      <hr></hr>
      <div className="SalesDetail__Container__AllButtons">
        <div style={{ display: "flex" }}>
          <div>
            <InsertSupplier type="insert" />
          </div>
          <div style={{ marginLeft: "5px" }}>
            <InsertArticle type="insert" />
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ marginLeft: "5px" }}>
            <LinkAndClickButton
              text="Ruaj & i ri"
              link="#"
              onClick={() => {
                newInvoice();
              }} // ose funksioni yt këtu
            />
          </div>
          <div style={{ marginLeft: "5px" }}>
            <LinkAndClickButton
              text="Email"
              icon={<FaEnvelope />}
              link="#"
              onClick={() => {
                setShowEmailConfirmation(true);
              }}
            />
          </div>
          <div style={{ marginLeft: "5px" }}>
            {/* <PrintContent details={headerData} companyDetails={companiesData} articleDetails={articlePrintDetails} bankaccounts={bankAccounts} sasia="QtyOutput" actiontype="true" link={link} hasElectronicSeal={hasElectronicSeal} /> */}
            <ButtonGroup
              variant="contained"
              ref={anchorRef}
              // aria-label="Button group with a nested menu"
            >
              <PrintContent
                details={headerData}
                companyDetails={companiesData}
                articleDetails={articlePrintDetails}
                bankaccounts={bankAccounts}
                QTY="QtyOutput"
                sasia="fletDalje"
                actiontype="true"
                link={link}
                hasElectronicSeal={hasElectronicSeal}
              />
              <MuiButton
                style={{
                  width: "30px",
                  height: "35px",
                  marginTop: "10px",
                  borderRadius: "0 5px 5px 0",
                  backgroundColor: "#4E7B67",
                }}
                aria-controls={open ? "split-button-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                // aria-label="select print option"
                aria-haspopup="menu"
                onClick={handleToggle}
              >
                <ArrowDropDownIcon />
              </MuiButton>
            </ButtonGroup>
            <Popper
              sx={{ zIndex: 1 }}
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={hasElectronicSeal} // Lidh me `ElectronicSeal`
                            onChange={(event) =>
                              setHasElectronicSeal(event.target.checked)
                            } // Përditëson `ElectronicSeal` kur klikohet
                          />
                        }
                        label="Shfaq Vulen Elektronike"
                      />
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
          {/* <div style={{ marginLeft: "5px" }}>
                        <LinkAndClickButton
                            text="Fiscal"
                            icon={<FaTicketAlt />}
                            link="#"
                            onClick={() => { downloadReceiptFile(data); }}
                        />
                    </div> */}
          <div style={{ marginLeft: "5px" }}>
            <LinkAndClickButton
              text="Fshij"
              icon={<FaTrash />}
              link="#"
              onClick={() => {
                setShowDeleteTransactionID(true);
              }}
            />
          </div>
          <div style={{ marginLeft: "5px" }}>
            <LinkAndClickButton
              text="Mbyll"
              icon={<FaTimes />}
              link="/Sales/returnToSupplier"
            />
          </div>
        </div>
      </div>
      {/* <div className='header_paper2' style={{ display: "flex", justifyContent: "flex-end" }}></div> */}
      <HeaderPaperComponent />
      <Paper>
        <form onSubmit={handleSubmit} className="header_paper">
          <Box
            // component="form"
            sx={{
              "& .MuiTextField-root": { m: 1.3, width: handleTextFieldWidth },
            }}
            noValidate
            autoComplete="off"
          >
            {/* <p>Please fill in these fields first to proceed to the fields below</p> */}
            <div className="SalesDetail__Container__Form">
              <div className="SalesDetail__Container__Form__div">
                <div
                  className="SalesDetail__Container__Form__div__1"
                  style={{ marginTop: "13px" }}
                >
                  <div className="SalesDetail__Container__Form__div__2">
                    <TextField
                      className="SalesDetail__Container__Form__TextField__1"
                      required
                      id="invoiceNR"
                      label="Numri Fatures"
                      variant="outlined"
                      type="text"
                      name="InvoiceNr"
                      value={"DND-" + fiscalYear + "-" + invoiceNR}
                      onChange={(event) => {
                        setInvoiceNR(event.target.value);
                        checkInvoiceNumber(event.target.value);
                      }}
                      disabled={form1IsDisabled}
                      autoComplete="off"
                    />

                    <TextField
                      className="SalesDetail__Container__Form__TextField__1"
                      style={{ marginTop: "22px" }}
                      id="id"
                      select
                      label="Lloji Shitjes"
                      defaultValue=""
                      value={transactionsType}
                      onChange={(event) => {
                        setTransactionType(event.target.value);
                        fetchLastInvoiceNr(fiscalYear);
                      }}
                      required
                      disabled={form1IsDisabled}
                    >
                      {TranscationData.map((data) => (
                        <MenuItem key={data.id} value={data.id}>
                          {data.type}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextareaAutosize
                      style={{ height: "70px", marginLeft: "10px" }}
                      className="SalesDetail__Container__Form__TextField__1"
                      id="Comment"
                      label="Komenti"
                      type="text"
                      name="Comment"
                      value={coment}
                      onChange={(event) => setComent(event.target.value)}
                      variant="outlined"
                      disabled={form1IsDisabled}
                      autoComplete="off"
                    />
                  </div>
                  <div className="SalesDetail__Container__Form__TextField__date__Payment">
                    <TextField
                      className="SalesDetail__Container__Form__TextField__date"
                      id="date"
                      type="date"
                      variant="outlined"
                      name="Date"
                      label="Data Faturës"
                      value={date}
                      // onChange={(e) => { setDate(e.target.value); setPayDate(e.target.value); fetchLastInvoiceNr(); }}
                      onChange={handleDateChange}
                      disabled={form1IsDisabled}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        min: minDate, // Kufizimi minimal i datës
                        max: maxDate, // Kufizimi maksimal i datës
                      }}
                    />
                    <TextField
                      className="SalesDetail__Container__Form__TextField__Payment"
                      style={{ marginTop: "22px" }}
                      id="PaymentType"
                      select
                      label="Përzgjedh mënyren arkëtimit"
                      value={paymentOptions}
                      onChange={(event) => {
                        setPaymentOptions(event.target.value);
                        calculateAndSetPaymentDate(event.target.value);
                        fetchLastInvoiceNr(fiscalYear);
                      }}
                    >
                      <MenuItem key="0" value="0">
                        Pagesa Behet më vonë
                      </MenuItem>
                      {cashRegister.map((data) => (
                        <MenuItem key={data.AccountID} value={data.AccountID}>
                          {data.AccountName}
                        </MenuItem>
                      ))}
                    </TextField>
                    {paymentOptions != 0 ? (
                      <TextField
                        className="SalesDetail__Container__Form__TextField__date"
                        id="PayDate"
                        type="date"
                        variant="outlined"
                        label="Data Arkëtimit"
                        name="PayDate"
                        value={payDate}
                        // onChange={(e) => setDate(e.target.value)}
                        onChange={(event) => {
                          setPayDate(event.target.value);
                          fetchLastInvoiceNr(fiscalYear);
                        }}
                        disabled={form1IsDisabled}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    ) : (
                      <TextField
                        className="SalesDetail__Container__Form__TextField__date"
                        id="PayDate"
                        type="date"
                        variant="outlined"
                        label="Afati i pagesës"
                        name="PayDate"
                        value={payDate}
                        // onChange={(e) => setDate(e.target.value)}
                        onChange={(event) => {
                          setPayDate(event.target.value);
                          fetchLastInvoiceNr(fiscalYear);
                        }}
                        disabled={form1IsDisabled}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="SalesDetail__Container__Form__div__4">
                <div style={{ paddingTop: "10px" }}>
                  {/* <Autocomplete
                                        {...defaultPropsSuppliers}
                                        id="include-input-in-list"
                                        includeInputInList
                                        value={accField}
                                        onChange={handleAutocompleteChangeSuppliers}
                                        isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                        renderInput={(params) => (
                                            <TextField
                                                style={{ width: "95%" }}
                                                {...params}
                                                label="Kerko Klientin"
                                            // variant="filled"
                                            //   onKeyPress={handleKeyPress}
                                            />
                                        )}
                                    /> */}

                  <AccountsAutocompleteInsert
                    ledgerID={302}
                    value={accField}
                    label="Kerko Furnitorin"
                    onSelect={(account) => {
                      setSupplierID(account.AccountID);
                      setAccfield(account);
                      fetchLastInvoiceNr(fiscalYear);
                    }}
                    onClear={() => {
                      setSupplierID("");
                      setAccfield(null);
                    }}
                    labelId="AccountID"
                  />
                </div>

                <div style={{ display: "flex", paddingTop: "15px" }}>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__IDNumber"
                    id="outlined-basic"
                    label="Numri Identifikues"
                    variant="outlined"
                    name="IdentificationNumber"
                    value={
                      suppliersDetails.length > 0
                        ? suppliersDetails[0].IdentificationNumber
                        : ""
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    readOnly
                    autoComplete="off"
                  />
                  <TextField
                    className="SalesDetail__Container__Form__TextField__IDNumber"
                    id="outlined-basic"
                    label="Numri i TVSH-së"
                    variant="outlined"
                    name="VatNumber"
                    value={
                      suppliersDetails.length > 0
                        ? suppliersDetails[0].VATNumber
                        : ""
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    readOnly
                    autoComplete="off"
                  />
                </div>
                {hasClientBranch ? (
                  <div style={{ display: "flex" }}>
                    <Autocomplete
                      style={{ width: "95%" }}
                      {...defaultPropsClientBranch}
                      id="include-input-in-list"
                      includeInputInList
                      value={clientBranchField}
                      onChange={handleAutocompleteChangeClientBranch}
                      isOptionEqualToValue={(option, value) =>
                        option.ClientBranchID === value.ClientBranchID
                      } // Shto funksionin isOptionEqualToValue
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Zgjedh Njesin e klientit"
                          style={{ width: "100%" }}
                        />
                      )}
                    />
                  </div>
                ) : (
                  <div>
                    <TextField
                      className="SalesDetail__Container__Form__TextField__2"
                      id="outlined-basic"
                      label="Adresa"
                      variant="outlined"
                      name="Address"
                      value={
                        suppliersDetails.length > 0
                          ? suppliersDetails[0].Adress
                          : ""
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      readOnly
                      autoComplete="off"
                    />
                  </div>
                )}
              </div>
            </div>
          </Box>
        </form>
        {openDetails ? (
          <div className="SalesDetail__Container">
            <div style={{ backgroundColor: "gainsboro " }}>
              <hr></hr>
              {showInserForm && (
                <form
                  onSubmit={(e) => handleNewSubmit(e)}
                  className="header_paper"
                  onKeyPress={handleKeyPress}
                >
                  <Box
                    // component="form"
                    sx={{
                      "& .MuiTextField-root": {
                        m: 1.3,
                        width: handleTextFieldWidth,
                      },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    {showInventoryAlert && showInventoryAlert ? (
                      <ShowArticleInventoryAlert />
                    ) : (
                      ""
                    )}
                    <div className="SalesDetail__Container__Second__Form">
                      <div
                        className="SalesDetail__Container__Second__Form__Article"
                        style={{ paddingTop: "10px" }}
                      >
                        {/* <Autocomplete
                          fullWidth
                          {...defaultPropsArticle}
                          id="ArticleID"
                          includeInputInList
                          value={field}
                          onChange={handleAutocompleteChangeArticle}
                          isOptionEqualToValue={(option, value) =>
                            option.ArticleID === value.ArticleID
                          } // Shto funksionin isOptionEqualToValue
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Kerko Artikullin"
                              // variant="filled"
                              // onKeyPress={handleKeyPress}
                            />
                          )}
                          ListboxProps={{
                            style: {
                              maxHeight: "250px", // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                              overflow: "auto", // Aktivizoni scroll-in për pjesën tjetër
                            },
                          }}
                        /> */}{" "}
                        <ArticleAutocompleteInsert
                          // reloadKey={articlesReloadKey}
                          value={field}
                          label="Kerko Artikullin"
                          priceType="purchase"
                          onSelect={(article) => {
                            setArticleID(article.ArticleID);
                            fetchArticlesSalesPrice(article.ArticleID);
                            fetchArticlesSalesPrice(article.ArticleID);
                            fetchArticleInventory(article.ArticleID);
                            setField(article);
                            setShowInventoryAlert(true);
                          }}
                          onClear={() => {
                            setArticleID("");
                            setField(null);
                          }}
                          labelId="ArticleID"
                        />
                      </div>
                      <div className="SalesDetail__Container__Second__Form__details__OtherInputs">
                        <div className="SalesDetail__Container__Second__Form__details">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="QtyOutput"
                            type="text"
                            variant="outlined"
                            label="Sasia Dalje"
                            name="QtyOutput"
                            autoComplete="off"
                            required
                            value={
                              typeof qtyOutput === "number"
                                ? qtyOutput.toFixed(4)
                                : qtyOutput
                            }
                            onChange={(e) => setQtyOutput(e.target.value)}
                            onKeyUp={handleCalculatePriceWithoutVAT} // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            disabled={form2IsDisabled}
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="DiscountPercent"
                            type="text"
                            variant="outlined"
                            label="Rabati %"
                            name="DiscountPercent"
                            autoComplete="off"
                            value={
                              typeof discountPercent === "number"
                                ? discountPercent.toFixed(2)
                                : discountPercent
                            }
                            onChange={(e) => setDiscountPercent(e.target.value)}
                            onKeyUp={handleCalculatePriceWithRabat} // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            disabled={form2IsDisabled}
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="PriceWithoutVAT"
                            type="text"
                            variant="outlined"
                            label="Çmimi pa TVSH"
                            name="PriceWithoutVAT"
                            autoComplete="off"
                            value={
                              typeof priceWithoutVAT === "number"
                                ? priceWithoutVAT.toFixed(4)
                                : priceWithoutVAT
                            }
                            onChange={(e) => setPriceWithoutVAT(e.target.value)}
                            onKeyUp={handleCalculatePriceWithVAT}
                            disabled={form2IsDisabled}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="PriceWithVAT"
                            type="text"
                            variant="outlined"
                            label="Çmimi me TVSH"
                            name="PriceWithVAT"
                            autoComplete="off"
                            value={
                              typeof priceWithVAT === "number"
                                ? priceWithVAT.toFixed(4)
                                : priceWithVAT
                            }
                            onKeyUp={handleCalculatePriceWithoutVAT} // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            onChange={(e) => setPriceWithVAT(e.target.value)}
                            disabled={form2IsDisabled}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__Output"
                            id="Total"
                            label="Vlera me TVSH"
                            variant="outlined"
                            name="Total"
                            autoComplete="off"
                            value={
                              typeof total === "number"
                                ? total.toFixed(2)
                                : total
                            }
                            onChange={(event) => setTotal(event.target.value)}
                            onKeyUp={handleCalculatePrices}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled={form2IsDisabled}
                          />
                        </div>
                        <div className="butonat">
                          <div>
                            {insertingArticle ? (
                              <Button
                                variant="success"
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <CircularProgress
                                  style={{
                                    borderRadius: "0",
                                    color: "white",
                                    width: "30px",
                                    height: "30px",
                                    alignItems: "center",
                                  }}
                                />
                              </Button>
                            ) : (
                              <Button
                                type="submit"
                                variant="success"
                                disabled={form2IsDisabled}
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-plus-lg"></i>
                              </Button>
                            )}
                          </div>
                          <div>
                            <Button
                              variant="danger"
                              onClick={clearLine}
                              style={{
                                borderRadius: "0",
                                width: "45px",
                                height: "45px",
                              }}
                            >
                              <i class="bi bi-x-lg"></i>
                            </Button>
                          </div>
                        </div>
                        <div className="responsive">
                          <div className="responsive__butonat">
                            <div>
                              {insertingArticle ? (
                                <Button
                                  variant="success"
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <CircularProgress
                                    style={{
                                      borderRadius: "0",
                                      color: "white",
                                      width: "30px",
                                      height: "30px",
                                      alignItems: "center",
                                    }}
                                  />
                                </Button>
                              ) : (
                                <Button
                                  type="submit"
                                  variant="success"
                                  disabled={form2IsDisabled}
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-plus-lg"></i>
                                </Button>
                              )}
                            </div>
                            <div>
                              <Button
                                variant="danger"
                                onClick={clearLine}
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-x-lg"></i>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Box>
                </form>
              )}
              {showEditForm && (
                <div className="SalesDetail__Container">
                  <form
                    onSubmit={handleSubmitDetailLine}
                    className="header_paper"
                    onKeyPress={handleKeyPress}
                  >
                    <Box
                      // component="form"
                      sx={{
                        "& .MuiTextField-root": { m: 1.3, width: "41ch" },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      {/* <p style={{ color: "red", fontSize: "16px", fontStyle: "italic", borderBottom: "1px dashed red" }}>Click on a line to edit the data</p> */}
                      <div className="SalesDetail__Container__Second__Form">
                        <div
                          className="SalesDetail__Container__Second__Form__Article"
                          style={{ paddingTop: "12px" }}
                        >
                          {/* <Autocomplete
                            fullWidth
                            sx={{ m: 1.5 }}
                            {...defaultPropsArticleEdit}
                            id="ArticleID"
                            includeInputInList
                            onChange={handleAutocompleteChangeArticleEdit}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Artikulli"
                                // variant="filled"
                              />
                            )}
                            ListboxProps={{
                              style: {
                                maxHeight: "250px", // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                overflow: "auto", // Aktivizoni scroll-in për pjesën tjetër
                              },
                            }}
                            value={
                              articles.find(
                                (option) =>
                                  option.ArticleID === formDetailData.ArticleID,
                              ) || null
                            }
                          /> */}
                          <ArticleAutocompleteEdit
                            articleId={formDetailData.ArticleID}
                            labelId="ArticleID"
                            priceType="purchase"
                            onSelect={(article) => {
                              setFormDetailData((prev) => ({
                                ...prev,
                                ArticleID: article.ArticleID,
                              }));
                              fetchArticlesSalesPrice(
                                article.ArticleID,
                                "edit",
                              );
                            }}
                            onClear={() =>
                              setFormDetailData((prev) => ({
                                ...prev,
                                ArticleID: "",
                              }))
                            }
                          />
                        </div>
                        <div className="SalesDetail__Container__Second__Form__details__OtherInputs">
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              type="text"
                              id="QtyOutput"
                              name="QtyOutput"
                              label="Sasia dalje"
                              variant="outlined"
                              value={formDetailData.QtyOutput}
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithoutVAT("edit")
                              }
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="DiscountPercent"
                              type="text"
                              variant="outlined"
                              label="Rabati %"
                              name="DiscountPercent"
                              value={
                                typeof formDetailData.DiscountPercent ===
                                "number"
                                  ? formDetailData.DiscountPercent.toFixed(2)
                                  : formDetailData.DiscountPercent
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithRabat("edit")
                              } // Shtoni këtë për të shkaktuar një funksion pas humbjes së fokusit nga kjo fushë
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="PriceWithoutVAT"
                              type="text"
                              variant="outlined"
                              label="Price Without VAT"
                              name="PriceWithoutVAT"
                              autoComplete="off"
                              value={
                                typeof formDetailData.PriceWithoutVAT ===
                                "number"
                                  ? formDetailData.PriceWithoutVAT.toFixed(4)
                                  : formDetailData.PriceWithoutVAT
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithVAT("edit")
                              }
                              // disabled={form2IsDisabled}
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="PriceWithVAT"
                              type="text"
                              variant="outlined"
                              label="Price With VAT"
                              name="PriceWithVAT"
                              autoComplete="off"
                              value={
                                typeof formDetailData.PriceWithVAT === "number"
                                  ? formDetailData.PriceWithVAT.toFixed(4)
                                  : formDetailData.PriceWithVAT
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() =>
                                handleCalculatePriceWithoutVAT("edit")
                              }
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details">
                            <TextField
                              className="SalesDetail__Container__Form__TextField__Output"
                              id="Total"
                              label="Total"
                              variant="outlined"
                              name="Total"
                              value={
                                typeof formDetailData.Total === "number"
                                  ? formDetailData.Total.toFixed(2)
                                  : formDetailData.Total
                              }
                              onChange={handleInputChangeDetail}
                              onKeyUp={() => handleCalculatePrices("edit")}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>

                          <div className="butonat">
                            <div>
                              <Button
                                type="submit"
                                variant="success"
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-check-lg"></i>
                              </Button>
                            </div>
                            <div>
                              <Button
                                variant="danger"
                                onClick={clearEdit}
                                style={{
                                  borderRadius: "0",
                                  width: "45px",
                                  height: "45px",
                                }}
                              >
                                <i class="bi bi-x-lg"></i>
                              </Button>
                            </div>
                          </div>
                          <div className="responsive">
                            <div className="responsive__butonat">
                              <div>
                                <Button
                                  type="submit"
                                  variant="success"
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-check-lg"></i>
                                </Button>
                              </div>
                              <div>
                                <Button
                                  variant="danger"
                                  onClick={clearEdit}
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-x-lg"></i>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Box>
                  </form>
                </div>
              )}

              <DataGridWithActions
                columns={detailsData}
                rows={rows}
                handleEdit={handleEditDetails}
                handleDelete={handleDelete}
                showPayment={false}
              />
            </div>
            <br></br>
            <div className="responsive__Tablet">
              <div className="SalesDetail__Container__Form">
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Amount18"
                    // style={{ width: "100%" }}
                    id="Amount18"
                    label="Vlera 18%"
                    variant="outlined"
                    type="text"
                    name="Amount18"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Amount18.toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VAT18"
                    // style={{ width: "100%" }}
                    id="VAT18"
                    label="TVSH 18%"
                    variant="outlined"
                    type="text"
                    name="VAT18"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].VAT18.toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Amount8"
                    // style={{ width: "100%" }}
                    id="Amount8"
                    label="Vlera 8%"
                    variant="outlined"
                    type="text"
                    name="Amount8"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Amount8.toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VAT8"
                    // style={{ width: "100%" }}
                    id="VAT8"
                    label="TVSH 8%"
                    variant="outlined"
                    type="text"
                    name="VAT8"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].VAT8.toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Amount0"
                    // style={{ width: "100%" }}
                    id="Amount0"
                    label="Vlera 0%"
                    variant="outlined"
                    type="text"
                    name="Amount0"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Amount0.toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VAT0"
                    // style={{ width: "100%" }}
                    id="VAT0"
                    label="Vlera para zbritjes"
                    variant="outlined"
                    type="text"
                    name="VAT0"
                    value={
                      valuedetails.length > 0
                        ? (
                            valuedetails[0].DiscountAmount +
                            (valuedetails[0].Amount18 +
                              valuedetails[0].Amount8 +
                              valuedetails[0].Amount0)
                          ).toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    style={{ width: "81%" }}
                    id="DiscountAmount"
                    label="Zbritja në vlerë"
                    variant="outlined"
                    type="text"
                    name="DiscountAmount"
                    value={discountAmount}
                    onChange={(e) => {
                      setDiscountAmount(e.target.value);
                      calculatePercent(e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Apliko Zbritjen" placement="right">
                            <IconButton
                              type="submit"
                              onClick={constUpdateDiscountAmount}
                            >
                              <i
                                class="bi bi-check-lg"
                                style={{ color: "green" }}
                              ></i>
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__TotalAmount"
                    id="TotalAmount"
                    label="Total pa TVSH"
                    variant="outlined"
                    type="text"
                    name="TotalAmount"
                    value={
                      valuedetails.length > 0
                        ? (
                            valuedetails[0].Amount18 +
                            valuedetails[0].Amount8 +
                            valuedetails[0].Amount0
                          ).toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                </div>
                <br></br>
                <div>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__VATTotal"
                    // style={{ width: "100%" }}
                    id="VATTotal"
                    label="Total TVSH"
                    variant="outlined"
                    type="text"
                    name="VATTotal"
                    value={
                      valuedetails.length > 0
                        ? (
                            valuedetails[0].Total -
                            (valuedetails[0].Amount18 +
                              valuedetails[0].Amount8 +
                              valuedetails[0].Amount0)
                          ).toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    className="SalesDetail__Container__Form__TextField__Total"
                    // style={{ width: "100%" }}
                    id="Totali"
                    label="Për pagesë"
                    variant="outlined"
                    type="text"
                    name="Totali"
                    value={
                      valuedetails.length > 0
                        ? valuedetails[0].Total.toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
            }}
          >
            {insertingTransaction ? (
              <button
                className="button-15"
                variant="contained"
                // type="submit"
                style={{
                  background: "#4E7B67",
                  width: "95%",
                  height: "55px",
                  alignContent: "center",
                  transition: "background-color 0.3s ease",
                  boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
                  color: "white",
                  border: "none",
                }}
              >
                <CircularProgress style={{ color: "white" }} />
              </button>
            ) : (
              <button
                className="button-15"
                variant="contained"
                type="submit"
                style={{
                  background: buttonContent.backgroundColor,
                  width: "95%",
                  height: "55px",
                  alignContent: "center",
                  transition: buttonContent.transcation,
                  boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
                  color: "white",
                  border: "none",
                }}
                disabled={form1IsDisabled}
                // onClick={handleSubmit}
                onClick={invNumberExist > 0 ? null : handleSubmit}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = buttonContent.onMouseEnter;
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = buttonContent.onMouseLeave;
                }}
              >
                {buttonContent.text}
              </button>
            )}
          </div>
        )}
        <br></br>
      </Paper>
    </div>
  );
}
export default InsertReturnToSupplier;
